var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"payment-card",class:{
    'payment-card__active': _vm.active,
    'payment-card__error': _vm.error
  },on:{"click":function($event){return _vm.$emit('click')}}},[_c('payment-card-body',{attrs:{"card":_vm.card,"label":_vm.label}},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }